<template>
  <div class="modal-dialog cascading-modal modal-lg">
    <div class="modal-content" style="width: 158% !important; left: -200px">
      <div class="modal-header">
        <h4 class="modal-title" id="myLargeModalLabel">
          {{ aSinglePatient.firstName + " " + aSinglePatient.lastName }} -
          {{ val3 }} - {{ aSinglePatient.ptid }}
        </h4>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-hidden="true"
        >
          ×
        </button>
      </div>

      <div class="modal-body mb-1 pt-2">
        <div class="vtabs customvtab">
          <ul class="nav nav-tabs tabs-vertical" role="tablist">
            <li class="nav-item">
              <a
                class="nav-link text-nowrap"
                data-toggle="tab"
                href="#home3"
                role="tab"
                style="border: none"
                ><span class="hidden-sm-up"></span>
                <span class="hidden-xs-down" id="detailsC">Details</span>
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link text-nowrap"
                data-toggle="tab"
                href="#customDemo3"
                role="tab"
                style="border: none"
                ><span class="hidden-sm-up"></span>
                <span class="hidden-xs-down" id="customdemoC" >Custom Demo</span>
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link text-nowrap"
                data-toggle="tab"
                href="#insuranceList3"
                role="tab"
                style="border: none"
                ><span class="hidden-sm-up"></span>
                <span class="hidden-xs-down">Insurance</span>
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link text-nowrap"
                data-toggle="tab"
                href="#paymentRequestList3"
                @click="getPaymentResTabl()"
                role="tab"
                style="border: none"
                ><span class="hidden-sm-up"></span>
                <span class="hidden-xs-down">Payment Request</span>
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link text-nowrap"
                data-toggle="tab"
                href="#visitHistory3"
                role="tab"
                style="border: none"
                ><span class="hidden-sm-up"></span>
                <span class="hidden-xs-down">Visit History</span></a
              >
            </li>
            <li class="nav-item">
              <a
                id="paymentHistory"
                class="nav-link text-nowrap"
                data-toggle="tab"
                href="#paymentHistory3"
                role="tab"
                style="border: none"
                ><span class="hidden-sm-up"></span>
                <span class="hidden-xs-down">Payment History</span></a
              >
            </li>
            <li class="nav-item">
              <a
                @click="callAuditLogPatientId()"
                id="auditLogId"
                class="nav-link text-nowrap"
                data-toggle="tab"
                href="#auditLog"
                role="tab"
                style="border: none"
                ><span class="hidden-sm-up"></span>
                <span class="hidden-xs-down">Audit Log</span></a
              >
            </li>
            <!-- <li class="nav-item">
                    <a
                      id="emailHistory1221"
                      class="nav-link text-nowrap"
                      data-toggle="tab"
                      href="#emailHistory"
                      role="tab"
                      style="border: none"
                      ><span class="hidden-sm-up"></span>
                      <span class="hidden-xs-down"
                        >Email History<span class="badge badge-danger mr-1">
                        </span></span
                    ></a>
                  </li>
                  <li class="nav-item">
                    <a
                    @click="textHistoryClick()"
                      id="textHistory1221"
                      class="nav-link text-nowrap"
                      data-toggle="tab"
                      href="#textHistory3"
                      role="tab"
                      style="border: none"
                      ><span class="hidden-sm-up"></span>
                      <span class="hidden-xs-down"
                        >Text History<span class="badge badge-danger mr-1">
                        </span></span
                    ></a>
                  </li> -->
            <!-- <li class="nav-item">
                    <a
                      class="nav-link text-nowrap"
                      data-toggle="tab"
                      href="#auditList3"
                      @click="GetAuditLog()"
                      role="tab"
                      style="border: none"
                      ><span class="hidden-sm-up"></span>
                      <span class="hidden-xs-down">History</span>
                    </a>
                  </li> -->
          </ul>
          <!-- Tab panes -->
          <div class="tab-content" style="width: 100%">
            <div class="tab-pane profile-tab-pane" id="home3" role="tabpanel">
              <button
                class="btn btn-outline-success waves-effect col-12"
                :disabled="updButton == 0"
                @click="updateDetailsClick()"
              >
                Save
              </button>
              <div class="modal-body">
                <h3 class="font-weight-bold h3Spacing">Basic Details</h3>
                <form class="floating-labels">
                  <!-- first row 77-->
                  <div class="row">
                    <div class="col-lg-6">
                      <!-- first name -->
                      <div
                        class="form-group m-b-40"
                        :class="[
                          aSinglePatient.firstName != null ? '' : 'focused',
                        ]"
                      >
                        <span class="p-float-label">
                          <InputText
                            type="text"
                            class="form-control float-class"
                            id="firstName"
                            maxlength="50"
                            placeholder=""
                            v-model="aSinglePatient.firstName"
                          /><span class="bar"></span>
                          <label for="" id="font1"
                            >First Name<span style="color: red"> *</span></label
                          >
                        </span>
                      </div>
                      <!-- first name -->
                    </div>
                    <div class="col-lg-6">
                      <!-- last name -->
                      <div
                        class="form-group m-b-40"
                        :class="[
                          aSinglePatient.lastName != null ? '' : 'focused',
                        ]"
                      >
                        <span class="p-float-label">
                          <InputText
                            type="text"
                            class="form-control float-class"
                            id="lastName"
                            placeholde=""
                            maxlength="50"
                            v-model="aSinglePatient.lastName"
                          /><span class="bar"></span>
                          <label for="" id="font1"
                            >Last Name<span style="color: red"> *</span></label
                          >
                        </span>
                      </div>
                      <!-- last name -->
                    </div>
                  </div>
                  <!-- first row -->

                  <!-- second row *77*-->
                  <div class="row">
                    <div class="col-lg-6">
                      <div
                        class="form-group m-b-40"
                        :class="[aSinglePatient.dob != null ? 'focused' : '']"
                      >
                        <input
                          type="date"
                          class="form-control"
                          id="dob"
                          placeholder=""
                          v-model="aSinglePatient.dob"
                        /><span class="bar"></span>
                        <label
                          for=""
                          style="font-weight: bold; margin-left: 2px"
                          >Date of Birth<span style="color: red">
                            *</span
                          ></label
                        >
                      </div>
                    </div>

                    <div class="col-lg-6">
                      <div
                        class="form-group m-b-40"
                        :class="[
                          aSinglePatient.gender != null ? 'focused' : '',
                        ]"
                      >
                        <select
                          class="form-control custom-select"
                          tabindex="1"
                          v-model="aSinglePatient.gender"
                        >
                          <option value="0">Choose a Gender</option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                          <option value="Other">Others</option></select
                        ><span class="bar"></span>
                        <label
                          for=""
                          style="font-weight: bold; margin-left: 2px"
                          >Gender<span style="color: red"> *</span></label
                        >
                      </div>
                    </div>
                  </div>
                  <!-- second row -->

                  <!-- fourth row -->
                  <div class="row">
                    <div class="col-lg-6">
                      <div
                        class="form-group m-b-40"
                        :class="[
                          aSinglePatient.externalId != null ? '' : 'focused',
                        ]"
                      >
                        <span class="p-float-label">
                          <InputText
                            type="text"
                            class="form-control float-class"
                            id="extrnalid"
                            placeholder=""
                            v-model="aSinglePatient.externalId"
                          /><span class="bar"></span>
                          <label for="" id="font1">External ID</label>
                        </span>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div
                        class="form-group m-b-40"
                        :class="[aSinglePatient.ssn != null ? '' : 'focused']"
                      >
                        <span class="p-float-label">
                          <InputText
                            v-mask="'###-##-####'"
                            type="tel"
                            class="form-control float-class"
                            id="ssns1"
                            placeholder=""
                            v-model="aSinglePatient.ssn"
                          /><span class="bar"></span>
                          <label for="" id="font1"
                            >Social Security Number
                          </label>
                        </span>
                      </div>
                    </div>
                  </div>
                  <!-- fourth row -->

                  <h3 class="font-weight-bold h3Spacing">
                    Contact Information
                  </h3>
                  <!-- third row -->
                  <div class="row">
                    <div class="col-lg-6">
                      <div
                        class="form-group m-b-40"
                        :class="[aSinglePatient.phone != null ? '' : 'focused']"
                      >
                        <span class="p-float-label">
                          <InputText
                            type="tel"
                            class="form-control float-class"
                            id="Phones1"
                            v-mask="'###-###-####'"
                            v-model="aSinglePatient.phone"
                          /><span class="bar"></span>
                          <label for="" id="font1">Phone Number </label>
                        </span>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div
                        class="form-group m-b-40"
                        :class="[aSinglePatient.email != null ? '' : 'focused']"
                      >
                        <span class="p-float-label">
                          <InputText
                            type="email"
                            class="form-control float-class"
                            id="emails1"
                            placeholder=""
                            maxlength="50"
                            v-model="aSinglePatient.email"
                          /><span class="bar"></span>
                          <label for="" id="font1">Email</label>
                        </span>
                      </div>
                    </div>
                  </div>
                  <!-- third row -->

                  <h3 class="font-weight-bold h3Spacing">Address</h3>
                  <!-- fifth row -->
                  <div class="row">
                    <div class="col-lg-6">
                      <div
                        class="form-group m-b-40"
                        :class="[
                          aSinglePatient.streetAddress != null ? '' : 'focused',
                        ]"
                      >
                        <span class="p-float-label">
                          <InputText
                            type="text"
                            class="form-control float-class"
                            id="streets1"
                            maxlength="100"
                            placeholder=""
                            v-model="aSinglePatient.streetAddress"
                          /><span class="bar"></span>
                          <label for="" id="font1">Street</label>
                        </span>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div
                        class="form-group m-b-40"
                        :class="[aSinglePatient.city != null ? '' : 'focused']"
                      >
                        <span class="p-float-label">
                          <InputText
                            type="text"
                            class="form-control float-class"
                            id="citys1"
                            placeholder=""
                            maxlength="50"
                            v-model="aSinglePatient.city"
                          /><span class="bar"></span>
                          <label for="" id="font1">City</label>
                        </span>
                      </div>
                    </div>

                    <div class="col-lg-6">
                      <div
                        class="form-group m-b-40"
                        :class="[aSinglePatient.zip != null ? '' : 'focused']"
                      >
                        <span class="p-float-label">
                          <InputText
                            type="text"
                            class="form-control float-class"
                            id="zips1"
                            maxlength="5"
                            placeholder=""
                            v-model="aSinglePatient.zip"
                          /><span class="bar"></span>
                          <label for="" id="font1">Zip</label>
                        </span>
                      </div>
                    </div>

                    <div class="col-lg-6">
                      <div
                        class="form-group m-b-40"
                        :class="[aSinglePatient.state != null ? '' : 'focused']"
                      >
                        <span class="p-float-label">
                          <select
                            class="form-control custom-select"
                            tabindex="1"
                            v-model="aSinglePatient.state"
                          >
                            <option value="">Choose State</option>
                            <option value="FL">FL</option>
                            <option value="AL">AL</option>
                            <option value="AK">AK</option>
                            <option value="AZ">AZ</option>
                            <option value="AR">AR</option>
                            <option value="CA">CA</option>
                            <option value="CO">CO</option>
                            <option value="CT">CT</option>
                            <option value="DE">DE</option>
                            <option value="GA">GA</option>
                            <option value="HI">HI</option>
                            <option value="ID">ID</option>
                            <option value="IL">IL</option>
                            <option value="IN">IN</option>
                            <option value="IA">IA</option>
                            <option value="KS">KS</option>
                            <option value="KY">KY</option>
                            <option value="ME">ME</option>
                            <option value="MD">MD</option>
                            <option value="MA">MA</option>
                            <option value="MI">MI</option>
                            <option value="MN">MN</option>
                            <option value="MS">MS</option>
                            <option value="MO">MO</option>
                            <option value="MT">MT</option>
                            <option value="NE">NE</option>
                            <option value="NV">NV</option>
                            <option value="NH">NH</option>
                            <option value="NJ">NJ</option>
                            <option value="NM">NM</option>
                            <option value="NY">NY</option>
                            <option value="NC">NC</option>
                            <option value="ND">ND</option>
                            <option value="OH">OH</option>
                            <option value="OK">OK</option>
                            <option value="OR">OR</option>
                            <option value="PA">PA</option>
                            <option value="RI">RI</option>
                            <option value="SC">SC</option>
                            <option value="SD">SD</option>
                            <option value="TN">TN</option>
                            <option value="TX">TX</option>
                            <option value="UT">UT</option>
                            <option value="VT">VT</option>
                            <option value="VA">VA</option>
                            <option value="WA">WA</option>
                            <option value="WV">WV</option>
                            <option value="WI">WI</option>
                            <option value="WY">WY</option>
                          </select>
                          <label for="" id="font1" style="margin-top: -31px"
                            >State</label
                          >
                        </span>
                      </div>
                    </div>
                  </div>
                  <!-- fifth row -->
                </form>
              </div>
            </div>
            <div
              class="tab-pane profile-tab-pane"
              id="customDemo3"
              role="tabpanel"
            >
            <div v-if="visitDemo.length === 0" ><p>No demo questions attached to patient profile</p></div>
            <div v-else>
                <button
                  class="btn btn-outline-success waves-effect col-12"
                  :disabled="updButton == 0"
                  @click="demoSaveClick"
                >
                  Save
                </button>
                <div class="modal-body">
                  <div class="row col-12">
                    <!-- demo id and  demo it self -->
                    <div
                      class="col-6 fluid"
                      v-for="(demo, ndx07) in visitDemo"
                      :key="ndx07"
                    >
                      <h4 style="margin-top: 10px">
                        <b style="font-weight: bold">DID-{{ demo.questIdSerial }}: </b>
                        <b>{{ demo.question }}</b>
                      </h4>
                      <!--  TEXT  -->
                      <div class="col-12" v-if="demo.questionInputTypeId == 1">
                        <fieldset class="floating-labels">
                          <div class="form-group m-b-40">
                            <input
                              type="text"
                              class="form-control required"
                              id=""
                              placeholder=""
                              v-model="demo.answer"
                            /><span class="bar"></span>
                          </div>
                        </fieldset>
                      </div>
                      <!--  END TEXT  -->

                      <!--  *-*CHECK BOX  -->
                      <div
                        class="col-12 align-self-left text-left"
                        v-if="demo.questionInputTypeId === 2"
                      >
                        <div class="input-group">
                          <div
                            class="row"
                            v-for="(opt, ndxA1) in demo.options"
                            :key="ndxA1"
                          >
                            <div style="margin-right: 10px">
                              <input
                                class="input1"
                                type="checkbox"
                                value="3"
                                name="checkbox"
                                id=""
                              />
                              <!-- <label
                                      v-if="opt.questOptionId == demo.answer"
                                      style="background-color: #00bfff"
                                      for="checkbox1"
                                      @click="demoOptionSelected(demo, opt, 'check-box')"
                                      class="btn"
                                      >{{ opt.questOption }}</label
                                    > -->
                              <label
                                for="checkbox1"
                                @click="
                                  demoOptionSelected(demo, opt, 'check-box')
                                "
                                :class="
                                  demo.answer.includes(opt.questOptionId)
                                    ? 'btn btn-info label1'
                                    : 'btn btn-outline-info label1'
                                "
                                >{{ opt.questOption }}</label
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--  END CHECK BOX  -->

                      <!--  RATING  -->
                      <div
                        class="col-12 align-self-left text-left"
                        v-if="demo.questionInputTypeId === 3"
                      >
                        <div class="input-group">
                          <div
                            class="row"
                            style="margin-right: 2px"
                            v-for="(opt, ndxA1) in demo.options"
                            :key="ndxA1"
                          >
                            <input
                              class="input1"
                              type="radio"
                              value="1"
                              name="radio"
                              id="radio1"
                            />
                            <label
                              v-if="opt.questOptionId == demo.answer"
                              style="background-color: #00bfff; color: white"
                              for="radio1"
                              class="btn label1"
                              :title="opt.questOption"
                              @click="demoOptionSelected(demo, opt)"
                              :class="
                                opt.questOptionId == demo.answer
                                  ? 'btn btn-info label1'
                                  : 'btn btn-outline-info label1'
                              "
                              >{{ opt.questOption }}</label
                            >
                            <label
                              v-else
                              for="radio1"
                              class="btn btn-outline-info label1"
                              style="color:#00bfff;margin-right"
                              :title="opt.questOption"
                              @click="demoOptionSelected(demo, opt)"
                              >{{ opt.questOption }}</label
                            >
                          </div>
                        </div>
                      </div>
                      <!--  END RATING  -->

                      <!--  RADIO BUTTON  -->
                      <div
                        class="col-6 m-b-40"
                        v-if="demo.questionInputTypeId === 4"
                      >
                        <div class="input-group">
                          <div class="row">
                            <div
                              style="margin-right: 10px"
                              v-for="(opt, ndxA1) in demo.options"
                              :key="ndxA1"
                            >
                              <input
                                class="input1"
                                type="radio"
                                value="1"
                                name="radio"
                                id="radio1"
                              />
                              <label
                                v-if="opt.questOptionId == demo.answer"
                                style="background-color: #00bfff; color: white"
                                for="radio1"
                                class="btn btn-outline-info label2"
                                @click="demoOptionSelected(demo, opt)"
                                >{{ opt.questOption }}</label
                              >
                              <label
                                v-else
                                for="radio1"
                                class="btn btn-outline-info label2"
                                @click="demoOptionSelected(demo, opt)"
                                >{{ opt.questOption }}</label
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--  END RADIO BUTTON  -->

                      <!--  EMAIL  -->
                      <div class="col-6" v-if="demo.questionInputTypeId === 5">
                        <fieldset class="floating-labels">
                          <div class="form-group m-b-40">
                            <input
                              type="text"
                              class="form-control required"
                              id=""
                              placeholder=""
                              maxlength="100"
                              v-model="demo.answer"
                            /><span class="bar"></span>
                          </div>
                        </fieldset>
                      </div>
                      <!--  END EMAIL  -->

                      <!--  PHONE  -->
                      <div class="col-6" v-if="demo.questionInputTypeId === 6">
                        <fieldset class="floating-labels">
                          <div
                            class="form-group m-b-40"
                            :class="[demo.answer != null ? 'focused' : '']"
                          >
                            <input
                              v-mask="'###-###-####'"
                              class="form-control required phone-inputmask"
                              id=""
                              placeholder=""
                              v-model="demo.answer"
                            /><span class="bar"></span>
                          </div>
                        </fieldset>
                      </div>

                      <!--  DATE  -->
                      <div class="col-6" v-if="demo.questionInputTypeId === 7">
                        <fieldset class="floating-labels">
                          <div class="form-group">
                            <input
                              type="date"
                              class="form-control"
                              id=""
                              v-model="demo.answer"
                            /><span class="bar"></span>
                          </div>
                        </fieldset>
                      </div>
                      <!--  END DATE  -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="tab-pane profile-tab-pane"
              id="insuranceList3"
              role="tabpanel"
            >
              <button
                class="btn btn-outline-success waves-effect col-12"
                :disabled="updButton == 0"
                @click="saveInsuranceClick"
              >
                Save
              </button>
              <div class="modal-body">
                <h3 class="font-weight-bold h3Spacing">Primary Insurance</h3>
                <form class="floating-labels">
                  <!-- first row -->
                  <div class="row">
                    <div class="col-lg-6">
                      <!-- Primary Insurance -->
                      <div
                        class="form-group m-b-40"
                        v-bind:class="[
                          aSinglePatient.insurance.primaryInsurance.length > 0
                            ? 'focused'
                            : '',
                        ]"
                      >
                        <span class="p-float-label">
                          <InputText
                            type="text"
                            class="form-control float-class"
                            id="pinsur"
                            placeholder=""
                            maxlength="100"
                            v-model="aSinglePatient.insurance.primaryInsurance"
                          /><span class="bar"></span>
                          <label for="" id="font1"> Primary Insurance </label>
                        </span>
                      </div>
                      <!-- Primary Insurance -->
                    </div>
                    <div class="col-lg-6">
                      <!-- Primary Insurance Number -->
                      <div
                        class="form-group m-b-40"
                        v-bind:class="[
                          aSinglePatient.insurance.primaryInsuranceNo != null
                            ? ''
                            : 'focused',
                        ]"
                      >
                        <span class="p-float-label">
                          <InputText
                            type="text"
                            class="form-control float-class"
                            id="pinsNo"
                            placeholder=""
                            maxlength="50"
                            v-model="
                              aSinglePatient.insurance.primaryInsuranceNo
                            "
                          /><span class="bar"></span>
                          <label for="" id="font1"
                            >Primary Insurance Number
                          </label>
                        </span>
                      </div>
                      <!-- Primary Insurance Number -->
                    </div>
                    <div class="col-lg-6">
                      <!-- Primary Insurance Group ID -->
                      <div
                        class="form-group m-b-40"
                        v-bind:class="[
                          aSinglePatient.insurance.primaryInsuranceGroupId
                            .length > 0
                            ? 'focused'
                            : '',
                        ]"
                      >
                        <span class="p-float-label">
                          <InputText
                            type="text"
                            class="form-control float-class"
                            id="insG"
                            placeholder=""
                            maxlength="50"
                            v-model="
                              aSinglePatient.insurance.primaryInsuranceGroupId
                            "
                          /><span class="bar"></span>
                          <label for="" id="font1"
                            >Primary Insurance Group ID
                          </label>
                        </span>
                      </div>
                      <!-- Primary Insurance Group ID -->
                    </div>
                    <!-- <div class="col-lg-6"> -->
                    <!-- Insurance ID -->
                    <!-- <div class="form-group m-b-40">
                              <input
                                type="file"
                                class="custom-file-input"
                                id="customFileLang_f"
                              />
                              <label
                                class="custom-file-label"
                                for="customFileLang"
                                id="customFileLang_fl"
                                >{{
                                  aSinglePatient.insurance.primaryInsuranceId
                                }}</label
                              >
                            </div> -->
                    <!-- Insurance ID -->
                    <!-- </div> -->
                  </div>
                  <!-- first row -->
                </form>

                <h3 class="font-weight-bold h3Spacing">Secondary Insurance</h3>
                <form class="floating-labels">
                  <!-- first row -->
                  <div class="row">
                    <div class="col-lg-6">
                      <!-- Secondary Insurance -->
                      <div
                        class="form-group m-b-40"
                        v-bind:class="[
                          aSinglePatient.insurance.secondaryInsurance.length > 0
                            ? 'focused'
                            : '',
                        ]"
                      >
                        <span class="p-float-label">
                          <InputText
                            type="text"
                            class="form-control float-class"
                            id="Sinsurance"
                            placeholder=""
                            maxlength="100"
                            v-model="
                              aSinglePatient.insurance.secondaryInsurance
                            "
                          /><span class="bar"></span>
                          <label for="" id="font1">Secondary Insurance </label>
                        </span>
                      </div>
                      <!-- Secondary Insurance -->
                    </div>
                    <div class="col-lg-6">
                      <!-- Secondary Insurance Number -->
                      <div
                        class="form-group m-b-40"
                        v-bind:class="[
                          aSinglePatient.insurance.secondaryInsuranceNo != null
                            ? ''
                            : 'focused',
                        ]"
                      >
                        <span class="p-float-label">
                          <InputText
                            type="text"
                            class="form-control float-class"
                            aria-labelledby="inuranceNo"
                            placeholder=""
                            maxlength="50"
                            v-model="
                              aSinglePatient.insurance.secondaryInsuranceNo
                            "
                          /><span class="bar"></span>
                          <label for="" id="font1"
                            >Secondary Insurance Number
                          </label>
                        </span>
                      </div>
                      <!-- Secondary Insurance Number -->
                    </div>
                    <div class="col-lg-6">
                      <!-- Secondary Insurance Group ID -->
                      <div
                        class="form-group m-b-40"
                        v-bind:class="[
                          aSinglePatient.insurance.secondaryInsuranceGroupId
                            .length > 0
                            ? 'focused'
                            : '',
                        ]"
                      >
                        <span class="p-float-label">
                          <InputText
                            type="text"
                            class="form-control float-class"
                            id="SinsuG"
                            placeholder=""
                            maxlength="50"
                            v-model="
                              aSinglePatient.insurance.secondaryInsuranceGroupId
                            "
                          /><span class="bar"></span>
                          <label for="" id="font1"
                            >Secondary Insurance Group ID
                          </label>
                        </span>
                      </div>
                      <!-- Secondary Insurance Group ID -->
                    </div>
                    <!-- <div class="col-lg-6"> -->
                    <!-- Insurance ID -->
                    <!-- <div class="form-group m-b-40">
                              <input
                                type="file"
                                class="custom-file-input"
                                id="customFileLang_s"
                              />
                              <label
                                class="custom-file-label"
                                for="customFileLang"
                                id="customFileLang_sl"
                              >
                                {{
                                  aSinglePatient.insurance.secondaryInsuranceId
                                }}</label
                              >
                            </div> -->
                    <!-- Insurance ID -->
                    <!-- </div> -->
                  </div>
                  <!-- first row -->
                </form>
              </div>
            </div>
            <div
              style="width: 1000px"
              class="tab-pane profile-tab-pane"
              id="paymentRequestList3"
              role="tabpanel"
            >
              <CollectPayments ref="cp" :AppModelId='AppModelId'></CollectPayments>
            </div>
            <div
              class="tab-pane"
              id="visitHistory3"
              role="tabpanel"
              style="overflow: hidden"
            >
              <div class="row justify-content-end">
                <div class="col-sm-4" style="left: -30px !important">
                  <div class="input-group mb-3">
                    <div class="col-sm-4">
                      <input
                        style="margin-bottom: 6px; margin-left: 51px"
                        type="text"
                        name="daterange"
                        :value="initDate_2"
                        @change="datePicker_2"
                        @focus="datePicker_2"
                      />
                      <div class="input-group-append">
                        <span
                          class="input-group-text"
                          style="
                            position: absolute;
                            margin-top: -34px;
                            margin-left: 230px;
                          "
                        >
                          <span class="ti-calendar"></span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="container" style="width: 933px">
                <div class="table-responsive">
                  <div
                    class="
                      dataTables_wrapper
                      container-fluid
                      dt-bootstrap4
                      no-footer
                    "
                  >
                    <div class="dataTables_length">
                      <span style="margin-right: 10px"
                        ><label for="">Show </label>
                      </span>
                      <select
                        v-model="VhpageSize"
                        class="form-control form-control-sm"
                        aria-label="Default select example"
                        @change="VhpageChange(1)"
                      >
                        <option selected>50</option>
                        <option value="100">100</option>
                        <option value="500">500</option>
                        <!-- <option value="1000">1000</option>
                              <option value="2000">2000</option> -->
                      </select>

                      <span style="margin-left: 10px">
                        <label for=""> Entries </label></span
                      >
                    </div>
                  </div>
                  <table
                    id="visitm"
                    class="table display table-bordered table-striped no-wrap"
                  >
                    <thead class="thead-dark">
                      <tr>
                        <th style="text-align: start">
                          Visit Type<span>
                            <button class="asc-desc-btn" @click="VhOrderBy(1)">
                              &uarr; &darr;
                            </button>
                          </span>
                        </th>
                        <th style="text-align: start">
                          Reason<span>
                            <button class="asc-desc-btn" @click="VhOrderBy(2)">
                              &uarr; &darr;
                            </button>
                          </span>
                        </th>
                        <th style="text-align: start">
                          DOS<span>
                            <button class="asc-desc-btn" @click="VhOrderBy(3)">
                              &uarr; &darr;
                            </button>
                          </span>
                        </th>
                        <th style="text-align: start">
                          Time In<span>
                            <button class="asc-desc-btn" @click="VhOrderBy(4)">
                              &uarr; &darr;
                            </button>
                          </span>
                        </th>
                        <th style="text-align: start">
                          Stage<span>
                            <button class="asc-desc-btn" @click="VhOrderBy(5)">
                              &uarr; &darr;
                            </button>
                          </span>
                        </th>
                        <th style="text-align: start">
                          Step<span>
                            <button class="asc-desc-btn" @click="VhOrderBy(6)">
                              &uarr; &darr;
                            </button>
                          </span>
                        </th>
                        <th style="text-align: start">
                          Physician<span>
                            <button class="asc-desc-btn" @click="VhOrderBy(7)">
                              &uarr; &darr;
                            </button>
                          </span>
                        </th>
                        <th style="text-align: start">
                          Comment<span>
                            <button class="asc-desc-btn" @click="VhOrderBy(8)">
                              &uarr; &darr;
                            </button>
                          </span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(vhis, ndx04) in visitHistory" :key="ndx04">
                        <td>{{ vhis.visitTypeName }}</td>
                        <td>{{ vhis.reason }}</td>
                        <td>{{ vhis.dosLocalDateStr }}</td>
                        <td>{{ vhis.dosLocalTimeStr }}</td>
                        <td>
                          <span v-if="vhis.isCheckedOut !== 1">
                            {{ vhis.stageName }}
                          </span>
                          <span v-else> Checked Out </span>
                        </td>
                        <td>
                          <span v-if="vhis.isCheckedOut !== 1">
                            {{ vhis.stepName }}
                          </span>
                          <span v-else> Checked Out </span>
                        </td>

                        <td>{{ vhis.physicianName }}</td>
                        <td>{{ vhis.commentText }}</td>
                      </tr>
                    </tbody>
                  </table>
                  <nav
                    aria-label="Page navigation"
                    style="width: 100%; float: right"
                  >
                    <!-- usmanbutt -->
                    <span
                      style="padding-left: 40px"
                      v-if="VhtotalRows < VhpageSize * VhpageNumber"
                      >showing {{ VhtotalRows }} of
                      {{ VhtotalRows }} records</span
                    >
                    <span style="padding-left: 40px" v-else
                      >showing {{ VhpageSize * VhpageNumber }} of
                      {{ VhtotalRows }} records</span
                    >
                    <ul class="pagination" style="float: right">
                      <li class="page-item colorActive">
                        <span v-if="VhpageNumber == 1">
                          <button
                            disabled
                            class="page-link disabledColor"
                            @click="VhpageChange('Previous')"
                          >
                            Previous
                          </button>
                        </span>
                        <span v-else>
                          <button
                            class="page-link"
                            @click="VhpageChange('Previous')"
                          >
                            Previous
                          </button>
                        </span>
                      </li>
                      <!--show pagination-->
                      <li v-if="showPagesMin1 > 1">
                        <button class="page-link" @click="VhpageChange(1)">
                          1
                        </button>
                      </li>
                      <li v-if="showPagesMin1 > 1">
                        <button disabled class="page-link disabledColor">
                          ...
                        </button>
                      </li>
                      <!--show pagination-->
                      <li
                        v-for="pageNum in VhtotalPages"
                        :key="pageNum"
                        class="page-item colorActive"
                      >
                        <span
                          v-if="
                            pageNum >= showPagesMin1 && pageNum <= showPagesMax1
                          "
                        >
                          <span v-if="VhpageNumber == pageNum"
                            ><button
                              class="page-link activeColor"
                              disabled
                              @click="VhpageChange(pageNum)"
                            >
                              {{ pageNum }}
                            </button>
                          </span>
                          <span v-else>
                            <button
                              class="page-link"
                              @click="VhpageChange(pageNum)"
                            >
                              {{ pageNum }}
                            </button></span
                          >
                        </span>
                      </li>

                      <!--show pagination-->
                      <li
                        v-if="
                          VhtotalPages > 10 && VhtotalPages - 4 >= VhpageNumber
                        "
                      >
                        <button disabled class="page-link disabledColor">
                          ...
                        </button>
                      </li>
                      <li
                        v-if="
                          VhtotalPages > 10 && VhtotalPages - 4 >= VhpageNumber
                        "
                      >
                        <button
                          class="page-link"
                          @click="pageChange(totalPages)"
                        >
                          {{ VhtotalPages }}
                        </button>
                      </li>
                      <!--show pagination-->
                      <li class="page-item colorActive">
                        <span v-if="VhpageNumber == VhtotalPages">
                          <button
                            disabled
                            class="page-link disabledColor"
                            @click="pageChange('Next')"
                          >
                            Next
                          </button>
                        </span>
                        <span v-else>
                          <button class="page-link" @click="pageChange('Next')">
                            Next
                          </button>
                        </span>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>

            <!-- Payment Received -->
            <div
              class="tab-pane profile-tab-pane"
              id="paymentHistory3"
              role="tabpanel"
              style="overflow: hidden"
            >
              <!-- <div style="display: none" class="row justify-content-end">
                      <div class="col-sm-4" style="left: -25px !important">
                        <div class="input-group mb-3">
                          <div class="col-sm-4">
                            <input
                              style="margin-bottom: 6px; margin-left: 51px"
                              type="text"
                              name="daterange"
                              :value="initDate_3"
                              @change="datePicker_3"
                              @focus="datePicker_3"
                            />
                            <div class="input-group-append">
                              <span
                                class="input-group-text"
                                style="
                                  position: absolute;
                                  margin-top: -34px;
                                  margin-left: 230px;
                                "
                              >
                                <span class="ti-calendar"></span>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> -->
              <div class="container" style="width: 933px">
                <div class="table-responsive">
                  <div
                    class="
                      dataTables_wrapper
                      container-fluid
                      dt-bootstrap4
                      no-footer
                    "
                  >
                    <div class="dataTables_length">
                      <span style="margin-right: 10px"
                        ><label for="">Show </label>
                      </span>
                      <select
                        v-model="VhpageSize"
                        class="form-control form-control-sm"
                        aria-label="Default select example"
                        @change="PhpageChange(1)"
                      >
                        <option selected>50</option>
                        <option value="100">100</option>
                        <option value="500">500</option>
                        <!-- <option value="1000">1000</option>
                              <option value="2000">2000</option> -->
                      </select>

                      <span style="margin-left: 10px">
                        <label for=""> Entries </label></span
                      >
                    </div>
                  </div>
                  <table
                    id="visitm"
                    class="table display table-bordered table-striped no-wrap"
                  >
                    <thead class="thead-dark">
                      <tr>
                         <th style="text-align: start">
                          Visit ID<span>
                            <button class="asc-desc-btn" @click="PhOrderBy(1)">
                              &uarr; &darr;
                            </button>
                          </span>
                        </th>
                         <th style="text-align: start">
                          Payment ID<span>
                            <button class="asc-desc-btn" @click="PhOrderBy(1)">
                              &uarr; &darr;
                            </button>
                          </span>
                        </th>
                        <th style="text-align: start">
                          DOS<span>
                            <button class="asc-desc-btn" @click="PhOrderBy(1)">
                              &uarr; &darr;
                            </button>
                          </span>
                        </th>
                        <th style="text-align: start">
                          Amount<span>
                            <button class="asc-desc-btn" @click="PhOrderBy(2)">
                              &uarr; &darr;
                            </button>
                          </span>
                        </th>
                        <th style="text-align: start">
                          Method<span>
                            <button class="asc-desc-btn" @click="PhOrderBy(3)">
                              &uarr; &darr;
                            </button>
                          </span>
                        </th>
                        <th style="text-align: start">
                          Comment<span>
                            <button class="asc-desc-btn" @click="PhOrderBy(4)">
                              &uarr; &darr;
                            </button>
                          </span>
                        </th>
                        <th style="text-align: start">
                          Stage<span>
                            <button class="asc-desc-btn" @click="PhOrderBy(5)">
                              &uarr; &darr;
                            </button>
                          </span>
                        </th>
                        <th style="text-align: start">
                          Collection Date<span>
                            <button class="asc-desc-btn" @click="PhOrderBy(6)">
                              &uarr; &darr;
                            </button>
                          </span>
                        </th>
                        <th style="text-align: start">
                          Collected By<span>
                            <button class="asc-desc-btn" @click="PhOrderBy(7)">
                              &uarr; &darr;
                            </button>
                          </span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(ph, ndx04) in paymentHistory" :key="ndx04">
                        <td>{{ ph.vid }}</td>
                        <td>{{ ph.paymentIdStr }}</td>
                        <td>{{ ph.dosStr }}</td>
                        <td>{{ ph.amount }}</td>
                        <td>{{ ph.paymentMethodStr }}</td>
                        <td>{{ ph.comment }}</td>
                        <td>{{ ph.statusStr }}</td>
                        <td>{{ ph.paymentDateStr }}</td>
                        <td>{{ ph.collectedByName }}</td>
                      </tr>
                    </tbody>
                  </table>
                  <nav
                    aria-label="Page navigation"
                    style="width: 100%; float: right"
                  >
                    <!-- usmanbutt -->
                    <span
                      style="padding-left: 40px"
                      v-if="PhtotalRows < PhpageSize * PhpageNumber"
                      >showing {{ PhtotalRows }} of
                      {{ PhtotalRows }} records</span
                    >
                    <span style="padding-left: 40px" v-else
                      >showing {{ PhpageSize * PhpageNumber }} of
                      {{ PhtotalRows }} records</span
                    >
                    <ul class="pagination" style="float: right">
                      <li class="page-item colorActive">
                        <span v-if="PhpageNumber == 1">
                          <button
                            disabled
                            class="page-link disabledColor"
                            @click="PhpageChange('Previous')"
                          >
                            Previous
                          </button>
                        </span>
                        <span v-else>
                          <button
                            class="page-link"
                            @click="PhpageChange('Previous')"
                          >
                            Previous
                          </button>
                        </span>
                      </li>
                      <!--show pagination-->
                      <li v-if="showPagesMin1 > 1">
                        <button class="page-link" @click="PhpageChange(1)">
                          1
                        </button>
                      </li>
                      <li v-if="showPagesMin1 > 1">
                        <button disabled class="page-link disabledColor">
                          ...
                        </button>
                      </li>
                      <!--show pagination-->
                      <li
                        v-for="pageNum11 in PhtotalPages"
                        :key="pageNum11"
                        class="page-item colorActive"
                      >
                        <span
                          v-if="
                            pageNum11 >= showPagesMin1 &&
                            pageNum11 <= showPagesMax1
                          "
                        >
                          <span v-if="PhpageNumber == pageNum11"
                            ><button
                              class="page-link activeColor"
                              disabled
                              @click="PhpageChange(pageNum11)"
                            >
                              {{ pageNum11 }}
                            </button>
                          </span>
                          <span v-else>
                            <button
                              class="page-link"
                              @click="PhpageChange(pageNum11)"
                            >
                              {{ pageNum11 }}
                            </button></span
                          >
                        </span>
                      </li>

                      <!--show pagination-->
                      <li
                        v-if="
                          PhtotalPages > 10 && PhtotalPages - 4 >= VhpageNumber
                        "
                      >
                        <button disabled class="page-link disabledColor">
                          ...
                        </button>
                      </li>
                      <li
                        v-if="
                          PhtotalPages > 10 && PhtotalPages - 4 >= VhpageNumber
                        "
                      >
                        <button
                          class="page-link"
                          @click="PhpageChange(PhtotalPages)"
                        >
                          {{ PhtotalPages }}
                        </button>
                      </li>
                      <!--show pagination-->
                      <li class="page-item colorActive">
                        <span v-if="PhpageNumber == PhtotalPages">
                          <button
                            disabled
                            class="page-link disabledColor"
                            @click="PhpageChange('Next')"
                          >
                            Next
                          </button>
                        </span>
                        <span v-else>
                          <button
                            class="page-link"
                            @click="PhpageChange('Next')"
                          >
                            Next
                          </button>
                        </span>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
            <!-- audit log -->
            <div
              class="tab-pane profile-tab-pane"
              id="auditLog"
              role="tabpanel"
            >
              <AuditLogComponent
                :patientId="patientIdProps"
                ref="auditLogComponent"
                :isModel="true"
              />
            </div>
            <div
              class="tab-pane profile-tab-paneV2"
              id="emailHistory"
              role="tabpanel"
            >
              <div class="tab-content">
                <div
                  class="tab-pane active"
                  id="inBoxv3"
                  role="tabpanel"
                  style="width: 1100px !important"
                >
                  <form class="">
                    <div class="col-10 bg-light">
                      <a
                        href=""
                        data-toggle="modal"
                        data-target="#sendEmail"
                        class="
                          btn btn-danger
                          m-b-20
                          p-10
                          btn-block
                          waves-effect waves-light
                        "
                        @click="sendEmailClick()"
                        >Compose</a
                      >
                      <div class="card-body p-t-0">
                        <div class="card b-all shadow-none">
                          <div class="inbox-center table-responsive">
                            <table class="table table-hover no-wrap">
                              <tbody>
                                <tr
                                  v-for="(emailHis, ndx01) in emailHistory"
                                  :key="ndx01"
                                  class=""
                                >
                                  <td>{{ ndx01 + 1 }})</td>
                                  <td style="width: 40px">
                                    <div
                                      class="
                                        custom-control custom-checkbox
                                        mr-sm-2
                                      "
                                    >
                                      <input
                                        type="checkbox"
                                        class="custom-control-input"
                                        id="checkbox0"
                                        value="check"
                                      />
                                      <!-- <label
                                              class="custom-control-label"
                                              for="checkbox0"
                                            ></label> -->
                                    </div>
                                  </td>
                                  <td
                                    style="width: 40px"
                                    class="hidden-xs-down"
                                  >
                                    <!-- <i class="far fa-star"></i> -->
                                  </td>
                                  <td class="hidden-xs-down">
                                    {{ emailHisUser }}
                                  </td>
                                  <td class="max-texts">
                                    <a
                                      href="javascript:void(0)"
                                      @click="
                                        getEmailInfor(
                                          emailHis.message,
                                          emailHis.emailTo,
                                          emailHis.subject
                                        )
                                      "
                                      class="nav-link"
                                      >{{ emailHis.subject }}</a
                                    >
                                  </td>
                                  <!-- <td class="hidden-xs-down">
                                          <a
                                            @click="getEmailInfor(emailHis.messageShort
                                            , emailHis.message, emailHis.emailTo, emailHis.subject)"
                                            >
                                          <i
                                          class="fa fa-paperclip"></i>
                                          </a>
                                        </td> -->

                                  <td class="text-right">
                                    {{ emailHis.emailDateStr }}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div
              class="tab-pane profile-tab-pane"
              id="auditList3"
              role="tabpanel"
            >
              <div class="row" v-for="(act, ndx) in auditData" :key="ndx">
                <div
                  class="col-12"
                  v-for="(dt, ndx01) in act.actionDates"
                  :key="ndx01"
                >
                  <div class="card">
                    <div class="card-body">
                      <ul class="timeline">
                        <li
                          v-for="(actType, ndx02) in dt.actionTypes"
                          :key="ndx02"
                          :class="ndx01 % 2 == 0 ? '' : 'timeline-inverted'"
                        >
                          <div class="timeline-badge warning">
                            <img
                              :src="getIcon(actType.actionTypeId)"
                              alt=""
                              style="height: 20px; margin: 16px"
                            />
                          </div>
                          <div class="timeline-panel">
                            <div class="row">
                              <div class="col-8">
                                <div class="timeline-heading">
                                  <p
                                    class="timeline-title"
                                    style="font-size: 20px; font-weight: 800"
                                  >
                                    {{ actType.actionTypeName }}
                                    <br /><small class="text-muted">{{
                                      actType.appModelName
                                    }}</small>
                                  </p>
                                </div>
                              </div>
                              <div class="col-4">
                                <h4 class="timeline-title">
                                  {{ act.actionToName }}
                                </h4>
                                <p>
                                  <small class="text-muted">
                                    <i class="fa fa-clock-o"></i
                                    >{{ dateToLocalString(dt.actionDate) }}
                                  </small>
                                </p>
                              </div>
                            </div>
                            <div class="timeline-body">
                              <p
                                v-for="(msg, ndx03) in actType.actionMessages"
                                :key="ndx03"
                              >
                                {{ msg }}
                              </p>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /.modal-content -->
  </div>
  <!-- /.modal-dialog -->
</template>

 <script>
import axios from "axios";
import AuditLogComponent from "./AuditLogComponent.vue";
import CollectPayments from "../Payments/CollectPayments.vue";
import moment from "moment";
export default {
  name: "PatientComponent",
    // StageDisplay = 1,
      // PatientPortal = 2,
      // SmsTemplate = 3,
      // EmailTemplate = 4,
      // StageAndStep = 5,
      // PaymentPortal=6,
      // Login=7,
      // CheckIn = 8,
      // LocationInfo = 9,
      // Physician = 10,
      // VisitType=11,
      // Task = 12,
      // Resource = 13,
      // Questionnaire = 14,
      // Demo = 15,
      // Payment = 16,
      // Upload = 17
  props: ["visitId", "patientId","FetchTableData","AppModelId"],
  components: {
    CollectPayments,
    AuditLogComponent,
  },
  data() {
    return {
      showProfilePopupVar: false,
      displaySearch: false,
      showPagesMin: 1,
      showPagesMax: 5,
      taskVisitId: 0,
      taskTable: false,
      patTasks: [],

      //SignalR
      MyUserId: 0,
      connection: {},
      startedPromise: {},

      //refund
      firstTime: true,
      refundAmount: "",
      //receipt
      SendReceiptRequest: {
        PatientId: 0,
        VisitId: 0,
        LocalDateTime: new Date(),
        BillNo: 0,
        PNDX: 0,
        Email: "",
        Phone: "",
        DC: "",
      },
      //reminder
      Reminder: [],
      btnProColl: false,
      //pay
      displayPayMethod: false,
      //-- Modals display
      cardModal: false,
      cashModal: false,
      chequeModal: false,
      ActivePaymentRequest: {},
      limitAmount: 0,

      //Page
      showPagesMin1: 1,
      showPagesMax1: 5,
      showPagesMin11: 1,
      showPagesMax11: 5,

      InviteType: ["SMS", "Email"],
      baseConvert: {},

      emailHide: "",
      phoneHide: "",

      displayRem1: false,
      displayRem2: false,
      displayRem: false,

      Email11: "",
      Phone11: "",
      selectInfo: "",
      //usmanbutt
      VhpageNumber: 1,
      VhpageSize: 50,
      VhtotalRows: 0,
      VhtotalPages: 0,

      //zahid
      PhpageNumber: 1,
      PhpageSize: 50,
      PhtotalRows: 0,
      PhtotalPages: 0,
      urlVal: "",
      //Data table MergeSugg
      pageNumberSuggest: 1,
      pageSizeSuggest: 50,
      totalPagesSuggest: 0,
      totalRowsSuggest: 0,

      //Data table MergeSugg
      pageNumberSuggest1: 1,
      pageSizeSuggest1: 50,
      totalPagesSuggest1: 0,
      totalRowsSuggest1: 0,

      practName: "",

      emailHisUser: "",
      textHistorySerch: [],
      Ownername: "",
      //Editor
      setReadonly: false,
      // email Editor
      Eeditor: false,
      Esubj: false,
      Eemail: false,
      Ename: false,
      // sms Editor
      Enumber: false,
      Esubj1: false,
      Ename1: false,
      loadObj: {},
      //email Info
      chatSms: "",
      activeVisitReasons: [],
      emailTo: "",
      subject: "",
      allFilterVisitHist: "",
      emailMessage: "",
      practiceID: "",
      //Date varibles
      val1: "",
      val2: "",
      val3: "",
      phone: "",
      email: "",
      ssn: "",
      address: "",
      city: "",
      state: "",
      zip: "",
      externalId: "",
      primaryInsurance: "",
      primaryInsuranceNo: "",
      primaryInsuranceId: "",
      primaryInsuranceGroupId: "",
      secondInsurance: "",
      secondInsuranceNo: "",
      secondInsuranceId: "",
      secondInsuranceGroupId: "",
      EmployeeRolesStr: [],
      updButton: 1,
      delButton: 1,
      //loader
      loader: "",
      //Timer
      intervalTime: 15000,
      TimerObject: {},
      RefreashObj: {},
      PvisitId: "",
      startDate: "",
      endDate: "",
      startDate_1: "",
      endDate_1: "",
      initDate: "",
      initDate_1: "",
      startDate_2: "",
      endDate_2: "",
      initDate_2: "",
      startDate_3: "",
      endDate_3: "",
      initDate_3: "",
      TextSearch: "",
      filterTextSearch: [],
      allFilterPatients_1: [],
      paymentStatus: [
        { text: "Sent", PValue: 1 },
        { text: "Pending", PValue: 2 },
        { text: "Disputed", PValue: 3 },
        { text: "Paid", PValue: 4 },
        { text: "Refund", PValue: 5 },
        { text: "Deleted", PValue: 6 },
      ],
      visitReasons: [],
      visitTypes: [],
      textHistory: [],
      visitHistory: [],
      allPatients: [],
      allInsurances: [],
      suggestedPatients: [],
      suggestedPatients1: [],

      allRawPatients: [],
      allFilterPatients: [],
      stagesSteps: [],
      emailHistory: [],
      allFilterPayHist: [],
      visitQuests: [],
      visitDemo: [],
      phyList: [],
      users: [],
      smsTempsList: [],
      selectedSmsId: 0,
      aSingleSms: {
        name: "",
        smsText: "",
      },
      aSingleUserSmsHist: [],
      auditData: [],
      emailTempsList: [],
      aSingleEmail: {
        name: "",
        emailText: "",
        emailSubject: "",
      },
      aSingleText: {
        userId: "",
      },
      filterPatList: [],
      filterNameF: "",
      filterNameL: "",

      filterFirstName: "",
      filterLastName: "",
      filterPhone: "",
      filterDate: "",
      filterDDate: "",
      //-- Actives
      aSinglePatient: {
        dos:"",
        practiceId: "",
        stats: {
          visits: 0,
          payments: 0,
          texts: 0,
          emails: 0,
        },
        insurance: {
          primaryInsurance: "",
          primaryInsuranceId: "",
          primaryInsuranceNo: "",
          primaryInsuranceGroupId: "",
          secondaryInsurance: "",
          secondaryInsuranceId: "",
          secondaryInsuranceNo: "",
          secondaryInsuranceGroupId: "",
        },
      },
      insurance: {
                primaryInsurance: "",
                primaryInsuranceId: "",
                primaryInsuranceNo: "",
                primaryInsuranceGroupId: "",
                secondaryInsurance: "",
                secondaryInsuranceId: "",
                secondaryInsuranceNo: "",
                secondaryInsuranceGroupId: "",
      },
      paymentHistory: [],
      requestPaymentsList: [],
      aSinglePaymentReceived: {
        pndx: 0,
        patientId: 0,
        practiceId: 0,
        visitId: 0,
        billNo: 0,
        collectedBy: 0,
        paymentDate: new Date(),
        amount: 0,
        paymentMethod: "",
        holderName: "",
        tdNumber: "",
        cardCVC: "",
        comment: "",
        zip: "",
      },
      aSingleRequestPayment: {
        amount: 0,
        email: "",
        phone: "",
        comment: "",
      },
      paymentReminder: {
        visitId: 0,
        email: "",
        phone: "",
        actionDate: new Date(),
      },
      aSelectedPatient: "",
      aSelectedInsurance: "",
      aSingleStage: "",
      activeStageNdx: -1,
      MyActiveStageNdx: 0,
      activeStep: -1,
      //-- Search
      mainSearch: {
        searchVeinsId: "",
        searchExternalId: "",
        searchFirstName: "",
        searchLastName: "",
        searchPhone: "",
        searchDate: null,
      },

      //-- Search
      suggested: {
        searchVeinsId: "",
        searchExternalId: "",
        searchFirstName: "",
        searchLastName: "",
        searchPhone: "",
        Dob: "",
        searchDate: null,
      },

      //-- Search
      suggested1: {
        searchVeinsId: "",
        searchExternalId: "",
        searchFirstName: "",
        searchLastName: "",
        searchPhone: "",
        Dob: "",
        searchDate: null,
      },

      // ***Sort Main Table
      mainSort: {
        name: 0,
        dos: 0,
        visitType: 0,
        timein: 0,
      },

      //-- Resources
      stageRes: [],
      stepRes: [],
      patResSumm: [],
      showResourceComponentDialog: false,

      //-- misc
      baseStagesSteps: "",
      operators: [],
      commentText: "",
      commentsList: [],
      showDropDownModal: false,
      p_visitId: Number,
      button_Name: String,

      isDelStepPressed: false,
      trackerStageStepStatus: ["inactive", "active", "complete", "skip"],
      // for merge
      VisitPayCounts: [],
      aSelectedCounts: [],
      mergedPat: {
        firstName: "",
        lastName: "",
        dob: "",
        gender: "",
        phone: "",
        email: "",
        ssn: "",
        address: "",
        streetAddress: "",
        externalId: "",
        city: "",
        state: "",
        zip: "",
        primaryIns: "",
        primaryInsNo: "",
        primaryInsId: "",
        primaryInsGroupId: "",
        secondIns: "",
        secondInsNo: "",
        secondInsId: "",
        secondInsGroupId: "",
        // will display table steps
      },
      stepsInStagesForTable: [],
      patientSteps: [],
      Image: "",
      showMerge: false,
      showCapturedData: [],
      //-- pagination
      totalRecords: 0,
      pagerows: 10,
      pageSize: 50,
      pageNumber: 1,
      stageId: 0,

      //payment
      pageNumberPays: 1,
      pageSizePays: 50,
      totalPagesPays: 0,
      totalRowsPays: 0,

      filteredPaymentRequests: "",

      //-- Filter
      showLoader: false,
      filter: {
        veinsId: "",
        externalId: "",
        firstName: "",
        lastName: "",
        phone: "",
        startDate: "",
        endDate: "",
      },

      sortColumnSuggest1: 0,
      sortColumnOptionSuggest1: 0,
      sortColumnSuggest: 0,
      sortColumnOptionSuggest: 0,

      //-- Date Menu for date search
      currentDateRange: "",
      mainSearchDate: null,
      dateMenu: [
        {
          label: "Today",
          command: () => {
            this.setDateToday();
          },
        },
        {
          label: "Yesterday",
          command: () => {
            this.setDateLastXDays(1);
          },
        },
        {
          label: "Last 7 Days",
          command: () => {
            this.setDateLastXDays(7);
          },
        },
        {
          label: "Last 30 Days",
          command: () => {
            this.setDateLastXDays(30);
          },
        },
        {
          label: "This Month",
          command: () => {
            this.setDateThisMonth();
          },
        },
        {
          label: "Last Month",
          command: () => {
            this.setDateLastMonth();
          },
        },
        {
          label: "Uptil Now",
          command: () => {
            this.setDateUptilNow();
          },
        },
        // {
        //   label: "Custom Range",
        //   command: () => {
        //     this.$toast.add({
        //       severity: "warn",
        //       summary: "Delete",
        //       detail: "Data Deleted",
        //       life: 3000,
        //     });
        //   },
        // },
      ],
    };
  },
  methods: {
    getPaymentResTabl() {
      this.intDummyComm();
      debugger;
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      this.dummyComm.appModelId = this.AppModelId;
      const url =
        this.SERVER + "/VNSPRAAPI/Trackers/GetActivePaymentRequestsListyId";
      const myData = this.dummyComm;
      console.log(this.aSinglePatient.visitId,this.aSinglePatient.patientId);
      this.$refs.cp.getPaymentResTable(this.aSinglePatient.visitId,this.aSinglePatient.patientId);   
   
      //this.axiosGetData(url, myData, 8000);
    },
      demoOptionSelected(demo, opt, what = "") {
      if (what == "check-box") {
          const ans = opt.questOptionId+'';
          let arr=demo.answer.split(',');
          if(arr.includes(ans)) {
            for (var i = 0; i < arr.length; i++) {
              if (arr[i] == ans) {
                arr.splice(i, 1);
                i--;
              }
            }
          }
          else arr.push(ans);
          demo.answer=arr.toString();
      } else demo.answer = opt.questOptionId;
    },
    demoSaveClick() {
      
      for (var j = 0; j < this.visitDemo.length; j++) {
        // if(this.visitDemo[j].answer == "") {
        //     this.ShowWarning("All Questionnaire Input is require");
        //     return;
        // }
        if (this.visitDemo[j].questTypeName == "Phone Number") {
          if (this.visitDemo[j].answer.length < 12) {
            this.ShowWarning("Phone must be of 10 length");
            return;
          }
        }
        // if (this.visitDemo[j].questTypeName == "Date") {
        //   if (!this.isValidateDate(this.visitDemo[j].answer)) {
        //     this.ShowWarning("Valid Date required");
        //     var d = new Date(this.visitDemo[j].answer);
        //     this.visitDemo[j].answer = moment(d).format('MM/dd/yyyy');
        //     console.log(this.visitDemo[j].answer);
        //     event.preventDefault();
        //     return;
        //   }
        // }
        if (this.visitDemo[j].questTypeName == "Date") {
          var checkDate = this.isValidDateTrue(this.visitDemo[j].answer);
          if(checkDate !== true)
          {
            this.ShowWarning("Please enter a valid date required");
            var d = new Date(this.visitDemo[j].answer);
             this.visitDemo[j].answer = moment(d).format('MM/dd/yyyy');
             console.log(this.visitDemo[j].answer);
             event.preventDefault();
             return;
          }
        }
        if (this.visitDemo[j].questTypeName == "Email") {
          if (this.visitDemo[j].answer != null) {
            if (!this.validEmail(this.visitDemo[j].answer)) {
              this.Validity(this.e);
            }
          }
        }
      }
      this.intDummyComm();
      this.dummyComm.pageNumber = this.pageNumber;
      this.dummyComm.pageSize = this.pageSize;
      this.dummyComm.visitId = this.aSinglePatient.visitId;
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      this.dummyComm.extras = this.aSelectedPatient.patientId;
      this.dummyComm.myDate = this.dateToSqlServerDateFormat(new Date());
      this.dummyComm.appModelId = this.AppModelId;
      const url = this.SERVER + "/VNSPRAAPI/Trackers/UpdVisQue";
      const myData = {
        dc: this.dummyComm,
        quests: this.visitDemo,
      };
      this.saveDemo(url, myData, 8);
      
    },
    async saveDemo( url, myData, what){
       var loader = this.$loading.show({
        color: "#03a9f3",
      });
       await axios({
        method: "post",
        url: url,
        data: myData,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          this.$nextTick(() => {
            $("#newptModalCom").on("shown.bs.modal", function (e) {
              console.log($(document).off("focusin.modal"));
            });
          });
           try {
              if (res.data.auditFlag > 0) {
                this.successToastUpd();
              } else this.errorToast(res.data.auditFlagVal);
            } catch {
              //this.calcTimerRoutine();
            }
        })
        .catch(function (error) {
          if (error.response) {
            // alert("-> " + error.response.data);
            // alert("-> " + error.response.status);
            // alert("-> " + error.response.headers);
          } else if (error.request) {
            //alert("No response " + error.request);
          } else {
            //alert("Error", error.message);
          }
        })
        .finally(() => {
          loader.hide();
          this.FetchTableData();
          this.ResetLogoutTime();
        });
    },
    saveInsuranceClick() {
      this.intDummyComm();
      this.dummyComm.visitId = this.aSinglePatient.visitId;
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      let obj = {
        pndx: 0,
        visitId: 0,
        patientId: 0,
        primaryInsurance: "",
        primaryInsuranceNo: "",
        primaryInsuranceGroupId: "",
        primaryInsuranceId: "",
        secondaryInsurance: "",
        secondaryInsuranceNo: "",
        secondaryInsuranceGroupId: "",
        secondaryInsuranceId: "",
      };
      //var firstfile = $("#customFileLang_f").val();
      //var Secfile = $("#customFileLang_s").val();
      var firstfile = $("#customFileLang_fl").html();
      var Secfile = $("#customFileLang_sl").html();
      obj = this.aSinglePatient.insurance;
      obj.patientId = this.dummyComm.patientId;
      obj.visitId = this.aSinglePatient.pndx;
      obj.primaryInsuranceId = firstfile;
      obj.secondaryInsuranceId = Secfile;
      this.dummyComm.visitId = this.aSinglePatient.visitId;
      this.dummyComm.extras = this.aSinglePatient.visitId;
      this.dummyComm.myDate = this.dateToSqlServerDateFormat(new Date());
      const url = this.SERVER + "/VNSPRAAPI/Patient/SavePatientInsurance";
      this.dummyComm.appModelId = this.AppModelId;
      const myData = {
        dc: this.dummyComm,
        patientInsuranceInfo: obj,
      };
      this.saveInsuranceC(url, myData, 17);
    },
    async saveInsuranceC(url, myData, what)
    {
      var loader = this.$loading.show({
        color: "#03a9f3",
      });
       await axios({
        method: "post",
        url: url,
        data: myData,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          this.$nextTick(() => {
            $("#newptModalCom").on("shown.bs.modal", function (e) {
              console.log($(document).off("focusin.modal"));
            });
          });
           try {
              if (res.data.auditFlag > 0) {
                this.successToastUpd();
              } else this.errorToast(res.data.auditFlagVal);
            } catch {
              //this.calcTimerRoutine();
            }
        })
        .catch(function (error) {
          if (error.response) {
            // alert("-> " + error.response.data);
            // alert("-> " + error.response.status);
            // alert("-> " + error.response.headers);
          } else if (error.request) {
            //alert("No response " + error.request);
          } else {
            //alert("Error", error.message);
          }
        })
        .finally(() => {
          loader.hide();
          this.FetchTableData();
          this.ResetLogoutTime();
        });
    },
    updateDetailsClick() {
      //For validation
      if (this.aSinglePatient.firstName == "") {
        this.ShowWarning("Firstname is require");
        event.preventDefault();
        return;
      } else if (this.aSinglePatient.lastName == "") {
        this.ShowWarning("Lastname is require");
        event.preventDefault();
        return;
      } else if (this.aSinglePatient.dob == "") {
        this.ShowWarning("Date of Birth is require");
        event.preventDefault();
        return;
      } else if (this.aSinglePatient.gender == "0") {
        this.ShowWarning("Gender is require");
        event.preventDefault();
        return;
      }
      if (!this.isValidateDate(this.aSinglePatient.dob)) {
        this.ShowWarning("Valid Date of Birth required");
        event.preventDefault();
        return;
      }

      if (this.aSinglePatient.email != null) {
        if (!this.validEmail(this.aSinglePatient.email)) {
          this.Validity(this.e);
        }
      }
      if (
        this.aSinglePatient.streetAddress == "undefined" ||
        this.aSinglePatient.streetAddress == ""
      ) {
        this.aSinglePatient.address = "";//stupid thing 
      }

      this.intDummyComm();
      this.dummyComm.extras = "";
      this.dummyComm.filter = "";
      this.dummyComm.pageNumber = this.pageNumber;
      this.dummyComm.pageSize = this.pageSize;
      this.dummyComm.appModelId = this.AppModelId;
      const darr = this.currentDateRange.split(" to ");
      let startDate = "";
      let endDate = "";

      if (darr[0] == "From start") startDate = new Date(1805, 1, 1);
      else startDate = new Date(darr[0]);
      endDate = new Date(darr[1]);

      const filter = {
        veinsId: this.mainSearch.searchVeinsId,
        externalId: this.mainSearch.searchExternalId,
        firstName: this.mainSearch.searchFirstName,
        lastName: this.mainSearch.searchLastName,
        phone: this.mainSearch.searchPhone,
        startDate: this.dateToYMD(startDate) + "",
        endDate: this.dateToYMD(endDate) + "",
        stageId: this.stageId,
      };
      const url = this.SERVER + "/VNSPRAAPI/Patient/SavePatientBasicInfo";
      this.aSinglePatient.isUpdateAppointmentTime = Boolean(this.aSinglePatient.isUpdateAppointmentTime);

      const myData = {
        dc: this.dummyComm,
        patientInfo: this.aSinglePatient,
        filter: filter,
        sort: this.mainSort,
      };
      this.SavePatientBasicInfo(url, myData, 5002);
    },
    async SavePatientBasicInfo(url, myData, what)
    {
      var loader = this.$loading.show({
        color: "#03a9f3",
      });
       await axios({
        method: "post",
        url: url,
        data: myData,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          this.$nextTick(() => {
            $("#newptModalCom").on("shown.bs.modal", function (e) {
              console.log($(document).off("focusin.modal"));
            });
          });
           try {
              if (res.data.auditFlag > 0) {
                this.successToastUpd();
              } else this.errorToast(res.data.auditFlagVal);
            } catch {
              //this.calcTimerRoutine();
            }
        })
        .catch(function (error) {
          if (error.response) {
            // alert("-> " + error.response.data);
            // alert("-> " + error.response.status);
            // alert("-> " + error.response.headers);
          } else if (error.request) {
            //alert("No response " + error.request);
          } else {
            //alert("Error", error.message);
          }
        })
        .finally(() => {
          loader.hide();
          this.FetchTableData();
          this.ResetLogoutTime();
        });
    },
    getPatientDataForPatientPortal(pat)
    {
      //for Date
      this.endDate = new Date();
      this.startDate = new Date();
      this.startDate.setDate(this.startDate.getDate() - 365);
      this.initDate_1 =
        this.dateToMDY(this.startDate) + " - " + this.dateToMDY(this.endDate);
      this.endDate_1 = new Date();
      this.startDate_1 = new Date();
      this.startDate_1.setDate(this.startDate_1.getDate() - 365);
      this.initDate =
        this.dateToMDY(this.startDate_1) +
        " - " +
        this.dateToMDY(this.endDate_1);
      this.endDate_2 = new Date();
      this.startDate_2 = new Date();
      this.startDate_2.setDate(this.startDate_2.getDate() - 365);
      this.initDate_2 =
        this.dateToMDY(this.startDate_2) +
        " - " +
        this.dateToMDY(this.endDate_2);

     //debugger
      //this.aSinglePatient = JSON.parse(JSON.stringify(pat));
      this.aSinglePatient.city =pat.city;
      this.aSinglePatient.doBstr = pat.doBstr;
      this.aSinglePatient.dob =pat.dob;
      this.aSinglePatient.dosLocalTime =pat.dosLocalTime;
      this.aSinglePatient.dosdate = pat.dosdate;
      this.aSinglePatient.dostime = pat.dostime;
      this.aSinglePatient.email = pat.email;
      this.aSinglePatient.emergencyNumber = pat.emergencyNumber;
      this.aSinglePatient.externalId =pat.externalId;
      this.aSinglePatient.firstName =pat.firstName;
      this.aSinglePatient.gender=pat.gender;
      this.aSinglePatient.isActive=pat.isActive;
      this.aSinglePatient.isMember=pat.isMember;
      this.aSinglePatient.lastName=pat.lastName;
      this.aSinglePatient.patientId=pat.patientId;
      this.aSinglePatient.patientPortalId=pat.patientPortalId;
      this.aSinglePatient.phone=pat.phone;
      this.aSinglePatient.practiceId=pat.practiceId;
      this.aSinglePatient.ptid = pat.ptid;
      this.aSinglePatient.ssn = pat.ssn;
      this.aSinglePatient.state = pat.state;
      this.aSinglePatient.streetAddress=pat.streetAddress;
      this.aSinglePatient.totalCount=pat.totalCount;
      this.aSinglePatient.visitId=pat.visitId;
      this.val3 = moment(String(this.aSinglePatient.dob)).format("MM/DD/YYYY");
      //date changes
      if (this.aSinglePatient.dosLocalTime != "") {
        this.val1 = this.aSinglePatient.dosLocalTime.split("-")[1];
        if (this.val1.length == 1) {
          this.val1 = "0" + this.val1;
        }
        this.val2 = this.aSinglePatient.dosLocalTime.split("T");
        this.val2 = this.val2[0].split("-")[0].substring(2, 4);
      }
      this.modalDate = moment(String(this.aSinglePatient.dob)).format(
        "MM-DD-YYYY"
      );
      var date = moment(String(this.aSinglePatient.dosdate)).format(
        "YYYY-MM-DD"
      );
      this.aSinglePatient.dob = date;
      //   this.intDummyComm();
      //   let url = this.SERVER + "/VNSPRAAPI/Trackers/GetEmailTemps";
      //   let myData = this.dummyComm;
      //   this.axiosGetData(url, myData, 15);

      this.intDummyComm();
      this.dummyComm.extras =
        this.aSinglePatient.pndx +
        this.UKEY +
        this.aSinglePatient.visitDetailId +
        this.UKEY +
        this.aSinglePatient.visitId +
        this.UKEY +
        this.aSinglePatient.patientId;
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      this.dummyComm.visitId = this.aSinglePatient.visitId;
      this.dummyComm.appModelId = this.AppModelId;
      this.patientIdProps = this.aSinglePatient.patientId;
      var url = this.SERVER + "/VNSPRAAPI/Patient/GetSnglPatAllData";
      var myData = this.dummyComm;
      this.getPatientDataAxios(url, myData);
    }, 
    getPatientData(pat) {
      debugger;
      if (pat.patientId < 0) {
        return;
      }
      this.endDate_2 = new Date();
      this.startDate_2 = new Date();
      this.startDate_2.setDate(this.startDate_2.getDate() - 365);
      this.initDate_2 =
        this.dateToMDY(this.startDate_2) +
        " - " +
        this.dateToMDY(this.endDate_2);
      this.endDate_1 = new Date();
      this.startDate_1 = new Date();
      this.startDate_1.setDate(this.startDate_1.getDate() - 365);
      this.initDate =
        this.dateToMDY(this.startDate_1) +
        " - " +
        this.dateToMDY(this.endDate_1);
      this.endDate_3 = new Date();
      this.startDate_3 = new Date();
      this.startDate_3.setDate(this.startDate_3.getDate() - 365);
      this.initDate_3 =
        this.dateToMDY(this.startDate_3) +
        " - " +
        this.dateToMDY(this.endDate_3);
      this.aSinglePatient = JSON.parse(JSON.stringify(pat));
      this.aSinglePatient.insurance = this.insurance; 
      this.aSinglePatient.ptid = this.aSinglePatient.ptid.replace(/ /g, "");

      $("#detailsC").click();
      var date = moment(String(this.aSinglePatient.dob)).format("YYYY-MM-DD");
      this.val3 = moment(String(this.aSinglePatient.dob)).format("MM/DD/YYYY");
   
        this.val1 = this.aSinglePatient.dos.split("T")[0];
      
        this.val2 = this.val1.split("-")[0].substring(2, 4);
        this.val1 = this.val1.split("-")[1];
        if (this.val1.length == 1) {
          this.val1 = "0" + this.val1;
        }
      this.aSinglePatient.dob = date + "";
      this.intDummyComm();
      let url = this.SERVER + "/VNSPRAAPI/Trackers/GetEmailTemps";
      let myData = this.dummyComm;
      //this.axiosGetData(url, myData, 15);
      this.intDummyComm();
      this.dummyComm.pageNumber = this.pageNumber;
      this.dummyComm.pageSize = this.pageSize;
      this.dummyComm.filter = "";
      this.dummyComm.visitId = this.aSinglePatient.visitId;
      this.dummyComm.appModelId = this.AppModelId;
      this.dummyComm.extras =
        this.aSinglePatient.pndx +
        this.UKEY +
        this.aSinglePatient.visitDetailId +
        this.UKEY +
        this.aSinglePatient.visitId +
        this.UKEY +
        this.aSinglePatient.patientId;
      url = this.SERVER + "/VNSPRAAPI/Patient/GetSnglPatAllData";
      myData = this.dummyComm;
     this.getPatientDataAxios(url,myData);
    },
    async getPatientDataAxios(url,myData)
    {
       this.loader = this.$loading.show({
        color: "#03a9f3",
      });
      await axios({
        method: "post",
        url: url,
        data: myData,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {      
          $("#customdemoC").click();
          if (res.data.dc.auditFlag === 1) {
            const pat = res.data.patient;
            this.insurance = res.data.insurances;
            debugger;
            if (this.insurance == null) {
              this.aSinglePatient.insurance = this.insurance = {
                primaryInsurance: "",
                primaryInsuranceId: "",
                primaryInsuranceNo: "",
                primaryInsuranceGroupId: "",
                secondaryInsurance: "",
                secondaryInsuranceId: "",
                secondaryInsuranceNo: "",
                secondaryInsuranceGroupId: "",
              };
            } else {
              this.aSinglePatient.insurance.primaryInsurance = this.insurance.primaryInsurance;
              this.aSinglePatient.insurance.primaryInsuranceId =  this.insurance.primaryInsuranceId;
              this.aSinglePatient.insurance.primaryInsuranceNo =  this.insurance.primaryInsuranceNo;
              this.aSinglePatient.insurance.primaryInsuranceGroupId =  this.insurance.primaryInsuranceGroupId;
              this.aSinglePatient.insurance.secondaryInsurance =  this.insurance.secondaryInsurance;
              this.aSinglePatient.insurance.secondaryInsuranceId =  this.insurance.secondaryInsuranceId;
              this.aSinglePatient.insurance.secondaryInsuranceNo =  this.insurance.secondaryInsuranceNo;
              this.aSinglePatient.insurance.secondaryInsuranceGroupId =  this.insurance.secondaryInsuranceGroupId;
            }

            //debugger
            //visitDemo Date
            this.visitDemo = res.data.quests.quests;
            for (let k = 0; k < this.visitDemo.length; k++) {
              if (this.visitDemo[k].questTypeName == "Date") {
                if (
                  this.visitDemo[k].answer !== "" ||
                  this.visitDemo[k].answer == "Invalid date"
                ) {
                  this.visitDemo[k].answer = moment(
                    String(this.visitDemo[k].answer)
                  ).format("YYYY-MM-DD");
                }
              }
            }

            this.visitQuests = res.data.quests.quests;
            this.requestPaymentsList = res.data.lpr;
            this.paymentHistory = res.data.paymentHistory;

            this.userTexts = res.data.userTexts;
            this.filterTextSearch = this.userTexts;
            this.emailHistory = res.data.emailHistory;
            this.PhpageNumber = res.data.dc.pageNumberP;
            this.PhpageSize = res.data.dc.pageSizeP;
            this.PhtotalPages = res.data.dc.totalPagesP;
            this.PhtotalRows = res.data.dc.totalRowP;
            this.visitHistory = res.data.visitHistory;
            //
            this.aSinglePatient.city =pat.city;
            this.aSinglePatient.doBstr = pat.doBstr;
            this.aSinglePatient.dob =pat.dob;
            this.aSinglePatient.dosLocalTime =pat.dosLocalTime;
            this.aSinglePatient.dosdate = pat.dosdate;
            this.aSinglePatient.dostime = pat.dostime;
            this.aSinglePatient.email = pat.email;
            this.aSinglePatient.emergencyNumber = pat.emergencyNumber;
            this.aSinglePatient.externalId =pat.externalId;
            this.aSinglePatient.firstName =pat.firstName;
            this.aSinglePatient.gender=pat.gender;
            this.aSinglePatient.isActive=pat.isActive;
            this.aSinglePatient.isMember=pat.isMember;
            this.aSinglePatient.lastName=pat.lastName;
            this.aSinglePatient.patientId=pat.patientId;
            this.aSinglePatient.patientPortalId=pat.patientPortalId;
            this.aSinglePatient.phone=pat.phone;
            this.aSinglePatient.practiceId=pat.practiceId;
            this.aSinglePatient.ptid = pat.ptid;
            this.aSinglePatient.ssn = pat.ssn;
            this.aSinglePatient.state = pat.state;
            this.aSinglePatient.streetAddress=pat.streetAddress;
            this.aSinglePatient.zip = pat.zip;
            //
            var date =  moment(
                    String(pat.doBstr)
                  ).format("YYYY-MM-DD");
            this.aSinglePatient.dob = date;
            this.aSinglePatient.externalId = res.data.patient.externalId;
            if (res.data.insurances != null) {
              this.insurance = res.data.insurances;
              if (this.insurance.secondaryInsuranceId == "")
                this.insurance.secondaryInsuranceId = "Secondary Id";
              if (this.insurance.primaryInsuranceId == "")
                this.insurance.primaryInsuranceId = "Insurance Id";
              //console.log((this.insurance = res.data.insurances));
            }
            this.users = res.data.users;
            // $("#newptModal").modal("show");
          }
        })
        .catch(function (error) {
          if (error.response) {
            // alert("-> " + error.response.data);
            // alert("-> " + error.response.status);
            // alert("-> " + error.response.headers);
          } else if (error.request) {
            //alert("No response " + error.request);
          } else {
            //alert("Error", error.message);
          }
        })
        .finally(() => {
                
          $("#detailsC").click();
          this.loader.hide();
          this.ResetLogoutTime();
         
        });
    },
      VhOrderBy(column) {
      if (this.firstTime == true) {
        this.firstTime = false;
        return;
      }
      this.orderByCol = column;
      if (column == 1) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.visitHistory = this.visitHistory.sort((a, b) =>
            a.visitTypeName < b.visitTypeName
              ? 1
              : b.visitTypeName < a.visitTypeName
              ? -1
              : 0
          );
        } else {
          this.asc_desc = "asc";
          this.visitHistory = this.visitHistory.sort((a, b) =>
            a.visitTypeName > b.visitTypeName
              ? 1
              : b.visitTypeName > a.visitTypeName
              ? -1
              : 0
          );
        }
      }
      if (column == 2) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.visitHistory = this.visitHistory.sort((a, b) =>
            a.reason < b.reason ? 1 : b.reason < a.reason ? -1 : 0
          );
        } else {
          this.asc_desc = "asc";
          this.visitHistory = this.visitHistory.sort((a, b) =>
            a.reason > b.reason ? 1 : b.reason > a.reason ? -1 : 0
          );
        }
      }
      if (column == 3) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.visitHistory = this.visitHistory.sort((a, b) =>
            a.dosLocalDateStr < b.dosLocalDateStr
              ? 1
              : b.dosLocalDateStr < a.dosLocalDateStr
              ? -1
              : 0
          );
        } else {
          this.asc_desc = "asc";
          this.visitHistory = this.visitHistory.sort((a, b) =>
            a.dosLocalDateStr > b.dosLocalDateStr
              ? 1
              : b.dosLocalDateStr > a.dosLocalDateStr
              ? -1
              : 0
          );
        }
      }
      if (column == 4) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.visitHistory = this.visitHistory.sort((a, b) =>
            a.dosLocalTimeStr < b.dosLocalTimeStr
              ? 1
              : b.dosLocalTimeStr < a.dosLocalTimeStr
              ? -1
              : 0
          );
        } else {
          this.asc_desc = "asc";
          this.visitHistory = this.practices.sort((a, b) =>
            a.dosLocalTimeStr > b.dosLocalTimeStr
              ? 1
              : b.dosLocalTimeStr > a.dosLocalTimeStr
              ? -1
              : 0
          );
        }
      }
      if (column == 5) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.visitHistory = this.visitHistory.sort((a, b) =>
            a.stageName < b.stageName ? 1 : b.stageName < a.stageName ? -1 : 0
          );
        } else {
          this.asc_desc = "asc";
          this.visitHistory = this.visitHistory.sort((a, b) =>
            a.stageName > b.stageName ? 1 : b.stageName > a.stageName ? -1 : 0
          );
        }
      }
      if (column == 6) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.visitHistory = this.visitHistory.sort((a, b) =>
            a.stepName < b.stepName ? 1 : b.stepName < a.stepName ? -1 : 0
          );
        } else {
          this.asc_desc = "asc";
          this.visitHistory = this.visitHistory.sort((a, b) =>
            a.stepName > b.stepName ? 1 : b.stepName > a.stepName ? -1 : 0
          );
        }
      }
      if (column == 7) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.visitHistory = this.visitHistory.sort((a, b) =>
            a.physicianName < b.physicianName
              ? 1
              : b.physicianName < a.physicianName
              ? -1
              : 0
          );
        } else {
          this.asc_desc = "asc";
          this.visitHistory = this.visitHistory.sort((a, b) =>
            a.physicianName > b.physicianName
              ? 1
              : b.physicianName > a.physicianName
              ? -1
              : 0
          );
        }
      }
      if (column == 8) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.visitHistory = this.visitHistory.sort((a, b) =>
            a.commentText < b.commentText
              ? 1
              : b.commentText < a.commentText
              ? -1
              : 0
          );
        } else {
          this.asc_desc = "asc";
          this.visitHistory = this.visitHistory.sort((a, b) =>
            a.commentText > b.commentText
              ? 1
              : b.commentText > a.commentText
              ? -1
              : 0
          );
        }
      }
      this.ResetLogoutTime();
    },
    callAuditLogPatientId() {
      this.$refs.auditLogComponent.loadInitPatient(
        this.aSinglePatient.patientId
      );
    },
    PhpageChange(obj) {
      if (obj == "Next") {
        if (this.PhpageNumber < this.PhtotalPages) {
          this.PhpageNumber += 1;
        }
      } else if (obj == "Previous" && this.PhpageNumber != 1) {
        this.PhpageNumber -= 1;
      } else {
        this.PhpageNumber = obj;
      }

      if (this.showPagesMax1 / 2 < this.PhpageNumber) {
        this.showPagesMin1 = this.PhpageNumber - 4;
        this.showPagesMax1 = this.PhpageNumber + 4;
      } else if (this.showPagesMin1 / 2 < this.PhpageNumber) {
        this.showPagesMin1 = this.PhpageNumber - 4;
        this.showPagesMax1 = this.PhpageNumber + 4;
        if (this.showPagesMax1 < 5) {
          this.showPagesMax1 = 5;
        }
      } else {
        this.showPagesMin1 = 1;
        this.showPagesMax1 = 5;
      }

      this.fetchPayHistory();
    },   
    StartLogoutTime() {
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },
    ResetLogoutTime() {
      clearTimeout(this.TimerObject);
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },
  },
  mounted() {},
};
</script>
<style scoped>
.p-multiselect-panel {
z-index: 1500;
}
</style>
